import React, { useState, useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Header from "./Components/Header";
import Customers from "./Pages/Customers/Customers";
import BookingManagement from "./Pages/BookingManagement/BookingManagement";
import ContentManagement from "./Pages/ContentManagement/ContentManagement";
import OrganiserManagement from "./Pages/OrganiserManagement/OrganiserManagement";
import Viewedit from "./Pages/VieweditOrganisermanagement/Viewedit";
import Reporting from "./Pages/Reporting/Reporting";
import CustomerProfileDetail from "./Pages/CustomerProfileDetails/CustomerProfileDetail";
import Feedback from "./Pages/Feedback/Feedback";
import Login from "./Pages/Login/Login";
import { useSelector, useDispatch } from "react-redux";
import Bookingmanagementview from "./Pages/Bookingmanagementview/Bookingmanagementview";
import EventManagement from "./Pages/EventManagement/EventsManagement";
import EventInformation from "./Pages/EventInformation/EventInformation";
import APIServices from "./services/APIServices";
import EventFeedBack from "./Pages/EventFeedBack/EventFeedBack";
import ProfileIDFeedBack from "./Pages/ProfileIDFeedBack/ProfileIDFeedBack";
import ProfileIDTripOrgFeedBack from "./Pages/ProfileIDTripOrgFeedBack/ProfileIDTripOrgFeedBack";
import EventMetrics from "./Pages/EventMetrics/EventMetrics";
import BookingMetrics from "./Pages/BookingMetrics/BookingMetrics";
import OrganiserReport from "./Pages/OrganiserReport/OrganiserReport";
import "./App.css";
import Popup from "./Pages/NoNetwork";
import { store } from "./store";
import { EnvironmentContext } from "./EnvironmentContext";
import IndividualFeedback from "./Pages/IndividualFeedback/IndividualFeedback";
import { setAccessToken, setUserDetails, setRefreshToken, setEventDetails } from "./Redux/Actions";

function App() {
  const { environment } = useContext(EnvironmentContext);
  const dispatch = useDispatch();
  const [refreshTokenExpired, setRefreshTokenExpired] = useState(false);
  const [logIn, setLogin] = useState(false);
  const [organiserManagementLength, setOrganiserManagementLength] = useState(null);
  const [bookingManagementLength, setBookingManagementLength] = useState(null);
  const [viewed, setViewed] = useState(null);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const tokenLocal = JSON.parse(localStorage.getItem("token"));
  const adminDetails = useSelector((state) => state?.loginUserDetails);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const accessToken = useSelector((state) => {
    return state.accessToken;
  });
  const refreshToken = useSelector((state) => {
    return state.refreshToken;
  });


  useEffect(() => {
    if (accessToken) {
      APIServices.setAuthToken(accessToken);
    }
    if (!sessionStorage.getItem('hasReloaded')) {
      sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, [accessToken]);

  // Check if the access token is expired
  const isAccessTokenExpired = (token) => {
    if (token) {
      const decodedToken = jwtDecode(token);
      return decodedToken.exp < Date.now() / 1000;
    }
    return false;
  };

  const generateNewToken = () => {
    if (!refreshToken) {
      alert("your session expired , login now")
      handleLogout();
      return;
    }
    console.log('refresh token called to get new access token')
    APIServices.generateNewToken({ refreshToken })
      .then((response) => {
        const newAccessToken = response.data.accessToken;
        localStorage.setItem("token", JSON.stringify(newAccessToken));
        dispatch(setAccessToken(newAccessToken));
        APIServices.setAuthToken(newAccessToken);
      })
      .catch((err) => {
        console.log("Error refreshing token:", err);
        handleLogout();
      });
  };
  const handleLogout = () => {
    localStorage.clear();
    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));
    dispatch(setUserDetails(null));
    dispatch(setEventDetails(null));
    setRefreshTokenExpired(true);
  };

  const checkTokenStatus = () => {
    if (isAccessTokenExpired(accessToken)) {
      console.log("Access token expired; refreshing...");
      generateNewToken();
    }

    // else {
    //   console.log("Access token still valid.");
    // }
  };


  // Focus listener to check token status on tab focus
  useEffect(() => {
    const handleTabFocus = () => {
      checkTokenStatus();
    };

    window.addEventListener("focus", handleTabFocus);
    return () => {
      window.removeEventListener("focus", handleTabFocus);
    };
  }, [accessToken]);


  useEffect(() => {
    if (accessToken) {
      APIServices.orgRequestUnviewed()
        .then(response => {
          const getUnViewdNotifications = response?.data?.UnviewedCount
          setOrganiserManagementLength(getUnViewdNotifications)
        })
        .catch(err => {
          console.log('Error calling org unviewed', err)
        })
    }



  }, [environment, organiserManagementLength, accessToken])

  useEffect(() => {
    APIServices.refundRequestViewedCount()
      .then((response) => {
        let total = 0;
        const eventss = response.data.Events.map((each) => {
          const filteredParticipants = each.participants.filter((single) =>
            single.reason_unattended != null && single.reason_unattended !== undefined
          );
          total += filteredParticipants.length;
        });
        setBookingManagementLength(total);
      })
      .catch((err) => {
        console.log("Error While Fetching refund request viewed false count: ", err);
      });
  }, [environment, bookingManagementLength, viewed]);

  return (
    <>
      {!isOnline && <Popup />}

      <Router>
        {refreshTokenExpired ? (
          <>
            <div style={{ marginTop: "72px" }} className="customer-cont-padding">
              <Header />
              <Login setLogin={setLogin} />
              {/* <Navigate to="/login" /> */}

            </div>


          </>
        ) : (
          <div style={{ marginTop: "72px" }} className="customer-cont-padding">
            <Header
              organiserManagementLength={organiserManagementLength}
              bookingManagementLength={bookingManagementLength}
            />
            <Routes>
              <Route path="/" element={isLoggedIn ? <Navigate to="/customer" /> : <Navigate to="/login" />} />
              <Route path="/login" element={<Login setLogin={setLogin} />} />
              <Route path="/customer" element={isLoggedIn ? <Customers /> : <Navigate to="/login" />} />
              <Route path="/allfeedbacks/eventfeedback/:id" element={isLoggedIn ? <EventFeedBack /> : <Navigate to="/login" />} />
              <Route path="/allfeedbacks/profilefeedback/:id" element={isLoggedIn ? <ProfileIDFeedBack /> : <Navigate to="/login" />} />
              <Route path="/allfeedbacks/organiser-profile-feedback/:id" element={isLoggedIn ? <ProfileIDTripOrgFeedBack /> : <Navigate to="/login/" />} />
              <Route path="/allfeedbacks/individual-feedback/:id" element={isLoggedIn ? <IndividualFeedback /> : <Navigate to="/login" />} />
              <Route path="/content-management" element={isLoggedIn ? <ContentManagement /> : <Navigate to="/login" />} />
              <Route path="/booking-management" element={isLoggedIn ? <BookingManagement /> : <Navigate to="/login" />} />
              <Route path="/event-management" element={isLoggedIn ? <EventManagement /> : <Navigate to="/login" />} />
              <Route path="/organiser-management" element={isLoggedIn ? <OrganiserManagement /> : <Navigate to="/login" />} />
              <Route path="/allfeedbacks" element={isLoggedIn ? <Feedback /> : <Navigate to="/login" />} />
              <Route path="/customer/:id" element={isLoggedIn ? <CustomerProfileDetail /> : <Navigate to="/login" />} />
              <Route path="/event-management/event/:id" element={isLoggedIn ? <EventInformation /> : <Navigate to="/login" />} />
              <Route path="/organiser-management/Viewedit/:id" element={isLoggedIn ? <Viewedit organiserManagementLength={organiserManagementLength} setOrganiserManagementLength={setOrganiserManagementLength} setViewed={setViewed} /> : <Navigate to="/login" />} />
              <Route path="booking-management/bookingdetails/:eventId" element={isLoggedIn ? <Bookingmanagementview bookingManagementLength={bookingManagementLength} setBookingManagementLength={setBookingManagementLength} setViewed={setViewed} /> : <Navigate to="/login" />} />
              <Route path="/reporting" element={isLoggedIn ? <Reporting /> : <Navigate to="/login" />} />
              <Route path="/reporting/eventmetrics" element={isLoggedIn ? <EventMetrics /> : <Navigate to="/login" />} />
              <Route path="/reporting/bookingmetrics" element={isLoggedIn ? <BookingMetrics /> : <Navigate to="/login" />} />
              <Route path="/reporting/organiserreport" element={isLoggedIn ? <OrganiserReport /> : <Navigate to="/login" />} />
            </Routes>
          </div>
        )}
      </Router></>


  );
}

export default App;

